import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";

import { MainConfig, NotifyService } from "@atenea-cms";
import { DashboardService } from "../shared/dashboard.service";

@Component({
  selector: "dashboard-screen",
  templateUrl: "./dashboard-screen.component.html",
  styleUrls: ["./dashboard-screen.component.scss"],
})
export class DashboardScreenComponent implements OnInit {
  constructor(
    private titleService: Title,
    private dashboardService: DashboardService,
    private notify: NotifyService,
    public mainConfig: MainConfig
  ) {}

  ngOnInit() {
    this.titleService.setTitle(this.mainConfig.cmsName);
  }

  clearCache() {
    this.dashboardService.clearCache().subscribe((data) => {
      if (data.status == "OK") {
        this.notify.success(data.message);
      } else {
        this.notify.warning(data.message);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/dashboard/dashboard-screen/dashboard-screen.component.ts